import React, { Fragment, useEffect, useState } from 'react'
import { getProfileTypes } from '../../actions/profileTypesActions'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import useAuth from '../../context/auth/useAuth'
import { Card, Col, Container, Row, Table } from 'react-bootstrap'
import { HeaderCandidate } from '../../components/headers/HeaderCandidate'
import { getCandidate } from '../../actions/candidatesActions'
import { softskillBlocksExport, hardskillBlocksExport } from '../../components/skillsBlocks'

export default function Report() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {candidate} = useSelector(state=>state.candidates)
    const {profileTypes} = useSelector(state=>state.profileTypes)

	const softskillBlocks = softskillBlocksExport
	const hardskillBlocks = hardskillBlocksExport

    const [profiles, setProfiles] = useState()

    useEffect(() => {
        if(client){
            dispatch(getCandidate(client?.id))
            dispatch(getProfileTypes())
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(profileTypes && candidate){
            let arrayProfiles = []
            let dataProfile = {}
            if(profileTypes.length > 0){
                profileTypes?.map((profiletypedata) => {
                    dataProfile = candidate?.profilestype?.find(profilestype => profilestype.profile_type === profiletypedata._id)
                    if(dataProfile){
                        dataProfile['name'] = profiletypedata.name
                        arrayProfiles.push(dataProfile)
                    }

                    return true
                })
            }

            setProfiles(arrayProfiles)
        }
    },[profileTypes, candidate])
    return (
        <>
            <Container className='cuerpo'>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-4 pt-5'>
                                <Row>
                                    <Col>
                                        <h2>{t('candidate.report')}</h2>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <h3>{t('profile.candidate.experiencestudy')}</h3>
                                        {candidate?.academic?.length > 0
                                            ?
                                                <Table striped bordered hover responsive size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>{t('profile.candidate.academictitle_type')}</th>
                                                            <th>{t('profile.candidate.academictitle')}</th>
                                                            <th>{t('profile.candidate.academicdescription')}</th>
                                                            <th>{t('profile.candidate.dates')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {candidate?.academic?.map((title, key) => (
                                                            <tr key={key}>
                                                                <td>{t('profile.candidate.'+title.title_type)}</td>
                                                                <td>{title.title}</td>
                                                                <td>{title.description}</td>
                                                                <td>
                                                                    {title.start_date ? title.start_date?.substr(8,2)+'/'+title.start_date?.substr(5,2)+'/'+title.start_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                    &nbsp;-&nbsp;
                                                                    {title.end_date ? title.end_date?.substr(8,2)+'/'+title.end_date?.substr(5,2)+'/'+title.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            :
                                                <>{t('profile.candidate.thereisnotacademic')}</>
                                        }
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <h3>{t('profile.candidate.experiencework')}</h3>
                                        {candidate?.professional?.length > 0
                                            ?
                                                <Table striped bordered hover responsive size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>{t('profile.candidate.work_type')}</th>
                                                            <th>{t('profile.candidate.position')}</th>
                                                            <th>{t('profile.candidate.descriptionwork')}</th>
                                                            <th>{t('profile.candidate.dates')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {candidate?.professional?.map((work, key) => (
                                                            <tr key={key}>
                                                                <td>{t('profile.candidate.'+work.work_type)}</td>
                                                                <td>{work.work}</td>
                                                                <td>{work.description}</td>
                                                                <td>
                                                                    {work.start_date ? work.start_date?.substr(8,2)+'/'+work.start_date?.substr(5,2)+'/'+work.start_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                    &nbsp;-&nbsp;
                                                                    {work.end_date ? work.end_date?.substr(8,2)+'/'+work.end_date?.substr(5,2)+'/'+work.end_date?.substr(0,4) : t('profile.candidate.nodate')}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            :
                                                <>{t('profile.candidate.thereisnotprofessional')}</>
                                        }
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <h3>{t('profile.candidate.profiles')}</h3>
                                        {profiles
                                            ?
                                                Object.keys(profiles).length > 0
                                                    ?
                                                        <>
                                                            {profiles?.map((profiletypedata, index) => (
                                                                <Fragment key={index}>
                                                                    <h4><strong>{profiletypedata.name}</strong></h4>
                                                                    <Row>
                                                                        <Col xs={12} sm={6}>
                                                                            {softskillBlocks?.map((softskillBlock, index2) => (
                                                                                <Fragment key={index2}>
                                                                                    {profiletypedata
                                                                                        ?
                                                                                            <>
                                                                                                {profiletypedata?.softskills[softskillBlock]?.length > 0
                                                                                                    ?
                                                                                                        <Col xs={12}><strong>{t('admin.dashboard.'+softskillBlock)}</strong></Col>
                                                                                                    :
                                                                                                        <></>
                                                                                                }
                                                                                                {profiletypedata?.softskills[softskillBlock]?.map((softskill, key) => (
                                                                                                    <Col xs={12} key={key} className='d-flex'>
                                                                                                        - {softskill}
                                                                                                    </Col>
                                                                                                ))}
                                                                                            </> 
                                                                                        :
                                                                                            <></>
                                                                                    }
                                                                                </Fragment>
                                                                            ))}
                                                                        </Col>
                                                                        <Col xs={12} sm={6}>
                                                                            {hardskillBlocks?.map((hardskillBlock, index3) => (
                                                                                <Fragment key={index3}>
                                                                                    {profiletypedata
                                                                                        ?
                                                                                            <>
                                                                                                {profiletypedata?.hardskills[hardskillBlock]?.length > 0
                                                                                                    ?
                                                                                                        <Col xs={12}><strong>{t('admin.dashboard.'+hardskillBlock)}</strong></Col>
                                                                                                    :
                                                                                                        <></>
                                                                                                }
                                                                                                {profiletypedata?.hardskills[hardskillBlock]?.map((hardskill, key) => (
                                                                                                    <Col xs={12} key={key} className='d-flex'>
                                                                                                        - {hardskill}
                                                                                                    </Col>
                                                                                                ))}
                                                                                            </> 
                                                                                        :
                                                                                            <></>
                                                                                    }
                                                                                </Fragment>
                                                                            ))}
                                                                        </Col>
                                                                    </Row>
                                                                </Fragment>
                                                            ))}
                                                        </>
                                                    :
                                                        <>{t('profile.candidate.thereisnotprofiles')}</>
                                            :
                                                <>{t('profile.candidate.thereisnotprofiles')}</>
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <h3>{t('profile.candidate.documents')}</h3>
                                        {candidate?.documents?.length > 0
                                            ?
                                                <Table striped bordered hover responsive size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>{t('profile.candidate.file_type')}</th>
                                                            <th>{t('profile.candidate.title')}</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {candidate?.documents?.map((document, key) => (
                                                            <tr key={key}>
                                                                <td>{t('profile.candidate.'+document.document_type)}</td>
                                                                <td>{document.title}</td>
                                                                <td>
                                                                    <a href={document.url} download={document.title}>
                                                                        <i className="fas fa-download"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            :
                                                <>{t('profile.candidate.thereisnotdocuments')}</>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <HeaderCandidate/>
        </>
    )
}